module.exports = __webpack_public_path__ + "img/placenta-low-lying.c0ed2551.png";